// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__7HTtU","icon":"styles_icon__3vzaP","statusOnline":"styles_statusOnline__3uHv2","statusOffline":"styles_statusOffline__1EVq8"};